import { render, staticRenderFns } from "./CardTextList.vue?vue&type=template&id=172ef876"
import script from "./CardTextList.vue?vue&type=script&lang=js"
export * from "./CardTextList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports